module.exports = __webpack_public_path__ + "static/media/hero.f9b82302.jpg";